import { useEffect } from 'react'
import { useHistory } from 'react-router'

export const usePreventBack = (preventBack: () => void) => {
  const history = useHistory()

  useEffect(() => {
    if (preventBack) {
      const unblock = history.block((_location, action) => {
        if (action === 'POP') {
          preventBack()
          return false
        }
      })

      return () => {
        unblock()
      }
    }
  }, [history, preventBack])
}
